// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fm-a";
export var fulfillmentFormRail = "_fm-9";
export var headerTitleRow = "_fm-c";
export var orderDetailsWrapper = "_fm-7";
export var orderLinkTrigger = "_fm-2";
export var paymentInformationGrid = "_fm-h";
export var paymentSummaryColumn = "_fm-i";
export var shipmentContainer = "_fm-b";
export var shipmentDetailsMainPane = "_fm-8";
export var shipmentNavigationCard = "_fm-5";
export var shipmentNavigationRail = "_fm-3";
export var shipmentNavigationRailHeader = "_fm-4";
export var shipmentSummaryFact = "_fm-e";
export var shipmentSummaryGrid = "_fm-d";
export var shipmentSummaryMetadataRow = "_fm-f";
export var shipmentSummaryTags = "_fm-g";
export var shipmentWorkspace = "_fm-0";
export var shipmentWorkspaceContent = "_fm-6";
export var shipmentWorkspaceHeader = "_fm-1";